<div class="icon-menu-container">
  <div class="icon-menu-item">
    <a [routerLink]="'/'" class="steel-works-logo-icon" [pTooltip]="'Home'">
      <bs-sw-logo-icon
        [iconFill]="'var(--p-bs-sidenav-iconcolor)'"
        class="icon-menu-logo"></bs-sw-logo-icon>
    </a>
  </div>

  <div class="flex flex-column">
    @for (item of items(); track item){
      <a [routerLink]="isDisabled(item) ? null : item?.routerLink"
         class="icon-menu-item"
         [ngClass]="{ 'icon-menu-item-disabled': isDisabled(item) }"
         [pTooltip]="isDisabled(item) ? 'Requires Web-app subscription' : ''"
         tooltipPosition="right"
         tooltipStyleClass="bs-sidenav-access-tooltip">
        <div [ngClass]="selectedRoute() === item.routerLink ? 'selected-icon-menu-item-child' : 'icon-menu-item-child'">
          <div [ngStyle]="{'height': 'var(--p-bs-sidenav-iconsize)', width: 'var(--p-bs-sidenav-iconsize)'}">
            <ng-container
              *ngComponentOutlet="item?.icon;
          inputs: {
            iconFill: 'var(--p-bs-sidenav-iconcolor)',
            width: 'var(--p-bs-sidenav-svgiconsize)',
            height: 'var(--p-bs-sidenav-svgiconsize)',
          }"
            >
            </ng-container>
          </div>
          <span [style]="{'font-size': '10px'}">{{ item?.label }}</span>

        </div>



      </a>
    }
  </div>

</div>
